module.exports = __webpack_public_path__ + "img/guara3.5b4e99d6.png";